import { motion } from "framer-motion";
import { useQuery } from "@tanstack/react-query";
import { ChefCard } from "@/components/Cards";
import { fetchChefs } from "@/lib/apiData";

export default function Directory({ type = "chef" }) {
  const { data: list = [] } = useQuery({ queryKey: ["chefs", type], queryFn: () => fetchChefs(type) });
  const isChef = type === "chef";

  return (
    <div data-testid={isChef ? "find-chefs-page" : "find-restaurants-page"} className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <p className="text-xs uppercase tracking-[0.25em] text-[#d00000] mb-3">{isChef ? "The talent" : "The venues"}</p>
        <h1 className="font-display text-5xl sm:text-6xl font-black tracking-tighter text-neutral-900">
          {isChef ? "Find indie chefs." : "Find restaurants."}
        </h1>
        <p className="mt-4 text-neutral-600 max-w-xl">
          {isChef
            ? "Discover verified independent chefs cooking their heritage from home kitchens near you."
            : "Explore verified restaurants bringing authentic cuisines to your door."}
        </p>
      </motion.div>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {list.map((c, i) => <ChefCard key={c.id} chef={c} index={i} />)}
      </div>
      {list.length === 0 && (
        <p className="py-24 text-center text-neutral-400" data-testid="directory-empty">Nothing here yet — check back soon.</p>
      )}
    </div>
  );
}
